import { Box as Box$1 } from '@xstyled/styled-components';

var Box = Box$1;

export { Box };
